import { FeatureEntitlementName } from '@jupiterone/entitlement-types';
import {
  ALERTS_PATH,
  ASSETS_PATH,
  COMPLIANCE_PATH,
  GRAPH_VIEWER_PATH,
  INSIGHTS_PATH,
  INTEGRATIONS_PATH,
  LANDING_PATH,
  MY_SECURITY_PATH,
  POLICIES_PATH,
} from '../constants';
import { ISession } from '../types';

const ROOT_URL =
  'https://raw.githubusercontent.com/JupiterOne/docs/main/assets/feature-previews/';

export function getPaywallImageUrlFromEntitlementName(
  featureEntitlementName: FeatureEntitlementName
): string {
  const map: { [key in FeatureEntitlementName]?: string } = {
    [FeatureEntitlementName.ALERTS]: ROOT_URL + 'preview-alerts-app_4x3.png',
    [FeatureEntitlementName.COMPLIANCE]:
      ROOT_URL + 'preview-compliance-app_4x3.png',
    [FeatureEntitlementName.GRAPH_VIEWER]:
      ROOT_URL + 'preview-graph-viewer-app_4x3.png',
    [FeatureEntitlementName.INSIGHTS]:
      ROOT_URL + 'preview-insights-app_4x3.png',
    [FeatureEntitlementName.INTEGRATIONS]:
      ROOT_URL + 'preview-integrations_4x3.png',
    [FeatureEntitlementName.INVENTORY]: ROOT_URL + 'preview-assets-app_4x3.png',
    [FeatureEntitlementName.LANDING]: ROOT_URL + 'preview-landing-app_4x3.png',
    [FeatureEntitlementName.MY_SECURITY]:
      ROOT_URL + 'preview-my-security-app_4x3.png',
    [FeatureEntitlementName.POLICIES]:
      ROOT_URL + 'preview-policies-app_4x3.png',
    [FeatureEntitlementName.POWER_UPS]: ROOT_URL + 'preview-powerups_4x3.png',
  };

  return map[featureEntitlementName] ?? '';
}

export function featureEntitlementNameToDisplayName(
  featureEntitlementName: FeatureEntitlementName
): string {
  // FeatureEntitlementNames are pascal case
  return featureEntitlementName.split(/(?=[A-Z])/).join(' ');
}

export function buildSupportMailToString(
  featureEntitlementName: FeatureEntitlementName,
  session: ISession
): string {
  const entitlementDisplayName = featureEntitlementNameToDisplayName(
    featureEntitlementName
  );

  const mailToString =
    `mailto:support@jupiterone.io\
  ?subject=${encodeURI(
    session.account?.id ?? ''
  )}%20requesting%20trial%20start%20for%20${encodeURI(
      entitlementDisplayName
    )}` +
    `&body=Hi%20JupiterOne%20team%2C%0A%0AThere%20was%20an%20error%20in%20the%20UI%20when%20I%20was%20trying%20to%20start%20my` +
    `%20free%20trial%20for%20${encodeURI(
      entitlementDisplayName
    )}.%0A%0AWill%20you%20enable%20my%20free%20trial%3F%0A%0AAccount%20Id` +
    `%20%3D%20${encodeURI(
      session.account?.id || 'Unknown Account Id'
    )}%0A%0AThanks%2C`;

  return mailToString;
}

const routesToFeatureEntitlementMap: {
  [key: string]: FeatureEntitlementName;
} = {
  [ALERTS_PATH]: FeatureEntitlementName.ALERTS,
  [ASSETS_PATH]: FeatureEntitlementName.INVENTORY,
  [COMPLIANCE_PATH]: FeatureEntitlementName.COMPLIANCE,
  [GRAPH_VIEWER_PATH]: FeatureEntitlementName.GRAPH_VIEWER,
  [INSIGHTS_PATH]: FeatureEntitlementName.INSIGHTS,
  [INTEGRATIONS_PATH]: FeatureEntitlementName.INTEGRATIONS,
  [LANDING_PATH]: FeatureEntitlementName.LANDING,
  [MY_SECURITY_PATH]: FeatureEntitlementName.MY_SECURITY,
  [POLICIES_PATH]: FeatureEntitlementName.POLICIES,
};

export function getFeatureEntitlementNameFromPathName(
  pathname: string
): FeatureEntitlementName | undefined {
  const foundEntry = Object.entries(routesToFeatureEntitlementMap).find(
    ([path]) => {
      return pathname.includes(path.replace(/\//g, ''));
    }
  );

  return foundEntry?.[1];
}
